import React from "react";
import PropTypes from "prop-types";
import { Button, Icon } from "semantic-ui-react";
import { HOST_URL } from "../../constants";
import { withPopup } from "../hoc";
import { getAccessToken } from "../../jwt";
const ButtonWithPopup = withPopup(Button);

const ProjectExportButton = ({ projectId }) => (
  <ButtonWithPopup
    as="a"
    href={`${HOST_URL}/recorder/api/projects/${projectId}?token=${getAccessToken()}`}
    icon
    size="tiny"
    popupProps={{ size: "mini", content: "Export", inverted: true }}
  >
    <Icon name="download" color="green" />
  </ButtonWithPopup>
);

ProjectExportButton.propTypes = {
  projectId: PropTypes.string.isRequired,
};

export default ProjectExportButton;
